import { on, createReducer } from '@ngrx/store';

import { Delivery, AssetGroup } from '../../models';
import * as fromActions from '../actions/delivery.actions';

export interface DeliveryState {
  data: Delivery;
  loading: boolean;
  loaded: boolean;
}

export const initialState: DeliveryState = {
  loading: false,
  loaded: false,
  data: {} as Delivery,
};

export const reducer = createReducer(
  initialState,
  on(fromActions.LoadDelivery, (state: DeliveryState, {}) => {
    const data = {} as Delivery;

    return { ...state, data, loading: true };
  }),
  on(fromActions.LoadDeliveryFail, (state: DeliveryState, {}) => (
    { ...state, loaded: false, loading: false }
  )),
  on(fromActions.LoadDeliverySuccess, (state: DeliveryState, { payload }) => {
    const data = payload;

    return { ...state, data, loaded: true, loading: false };
  }),
  on(fromActions.SetShareState, (state: DeliveryState, { payload }) => {
    const data = { ...state.data, share: payload } as Delivery ;

    return { ...state, data, loaded: true, loading: false };
  }),
  on(fromActions.SetDeliveryEmailText, (state: DeliveryState, { payload }) => {
    const data = { ...state.data, emailText: payload } as Delivery;

    return { ...state, data };
  }),
  on(fromActions.SetDeliveryLoading, (state: DeliveryState, { payload }) => {
    const loading = payload;

    return { ...state, loading };
  }),
);

export const selectData = (state: DeliveryState): Delivery => state.data;
export const selectLoading = (state: DeliveryState): boolean => state.loading;
export const selectLoaded = (state: DeliveryState): boolean => state.loaded;
export const selectAssetsGroup = (state: DeliveryState): AssetGroup[] => state.data.assetGroups;
